import React from "react";
import classNames from "classnames";
import { Switch } from "@mui/material";
import { SwitchFormFieldStyle } from "./switch-field.styled";

interface SwitchFieldProps {
  name: string;
  size?: "small" | "medium";
  label?: React.ReactNode;
  value?: boolean;
  defaultValue?: boolean;
  disabled?: boolean;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  handleChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  description?: string;
  error?: string;
}

export const SwitchField: React.FC<SwitchFieldProps> = ({
  name,
  size = "medium",
  label,
  value,
  disabled,
  defaultValue,
  onChange,
  handleChange,
  description,
  error,
}) => {
  return (
    <SwitchFormFieldStyle
      data-testid={`${name}-switch-field`}
      hasError={!!error}
    >
      {label && (
        <label htmlFor={name} className="switch-label">
          {label}
        </label>
      )}

      <Switch
        aria-label="switch-type"
        id={name}
        value={value}
        onChange={(e) => {
          onChange(e);
          if (handleChange) handleChange(e);
        }}
        defaultChecked={defaultValue !== undefined ? defaultValue : false}
        checked={!!value}
        disabled={disabled}
        size={size}
        className={classNames({ enabled: !disabled, disabled: disabled })}
        inputProps={{ "aria-label": typeof label === "string" ? label : "" }}
      />

      {(description || error) && (
        <span className="helper-text">{error || description}</span>
      )}
    </SwitchFormFieldStyle>
  );
};
